import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu May 09 2019
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable } from 'mobx';
import * as React from 'react';
import { LoadingState } from '../../../../../shared/api/LoadingState';

var CellTooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CellTooltip, _React$Component);

  function CellTooltip() {
    var _this;

    _classCallCheck(this, CellTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CellTooltip).apply(this, arguments));
    _this.loadingState = LoadingState.Pending;
    return _this;
  }

  _createClass(CellTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.reactContainer.className = 'cell-tooltip';
      this.load();
    }
  }]);

  return CellTooltip;
}(React.Component);

export { CellTooltip as default };

__decorate([observable, __metadata("design:type", Number)], CellTooltip.prototype, "loadingState", void 0);